// BackButton.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function BackButton() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // goes back in history
  };

  return (
    <button 
      onClick={handleBack} 
      style={{
        position: "fixed",
        top: "10px",
        left: "10px",
        padding: "8px 12px",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        zIndex: 1000
      }}
    >
      ← Back
    </button>
  );
}
